namespace Solovis.Reports.ReportControlHelpers {

    export class ReportControlHiddenPartOverrideDialog {

        public reportControl: Solovis.Reports.ReportControl;
       
        constructor(
            options: {
                reportControl: Solovis.Reports.ReportControl
            }
        ) {
            var self = this;

            this.reportControl = options.reportControl;            
        }

        public show() {
            let dialogDiv = $("<div>");

            $("<p>").text("Select named report parts to always hide (regardless of normal visibility settings). This can be used to adjust report displays within report stacks.")
                .appendTo(dialogDiv);

            let elementNameList = this.reportControl.getElementNameList();

            let elementStateList = [];

            for (let elementName of elementNameList) {
                let elementRow = $("<div>").appendTo(dialogDiv);

                let initiallySet = this.reportControl.isPartHiddenOverrideSet(elementName);

                let elementCheckDiv = $("<div>").appendTo(elementRow);
                let elementCheckBox = $(elementCheckDiv).dxCheckBox({
                    text: elementName,
                    value: initiallySet
                });

                let elementState = {
                    name: elementName,
                    elementCheckBox: elementCheckBox,
                    initiallySet: initiallySet
                };

                elementStateList.push(elementState);
            }

            let dialog = new Solovis.UI.Dialog({
                container: dialogDiv,

                title: "Hidden Part Overrides",

                width: 500,
                height: 400,
                modal: true,
                center: true,

                buttons: [
                    {
                        label: "OK",
                        click: () => {
                            // Apply changes.
                            for (let elementState of elementStateList) {
                                let isSet = !!$(elementState.elementCheckBox).dxCheckBox("instance").option("value");
                                if (isSet != elementState.initiallySet) {
                                    this.reportControl.setPartHiddenOverride(elementState.name, isSet);
                                }
                            }

                            dialog.close();
                        }
                    },
                    {
                        label: "Cancel",
                        click: () => {
                            dialog.close();
                        }
                    },
                ]
            });
            dialog.open();
        }        
    }

}
